if (typeof document !== 'undefined') {
    addEventListener('DOMContentLoaded', () => {
        const formElements = document.querySelectorAll('form[page-guid]');
        formElements.forEach((formElement) => {
            const pageGuid = formElement.getAttribute('page-guid');
            const action = formElement.getAttribute('action');
            const url = new URL(action, window.location.origin);
            url.searchParams.append('pageGuid', pageGuid);
            formElement.setAttribute('action', url.toString());
        });
    });
}
